function init() {
    jQuery(document).ready(function() {
        if ($('.related-grid-items-director').length > 0) {
            $('.post-single-video-iframe').append('<iframe title="' + $('.related-grid-items-director .col-6').eq(0).find('.grid-item .grid-item-title').text() + '" src="' + $('.related-grid-items-director .col-6').eq(0).find('.grid-item').data('video-url') + '" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>');

            $('.related-grid-items-director .grid-item').on('click', function(e) {
                if ($(this).data('video-url')) {
                    e.preventDefault();
                    $('.related-grid-items-director .col-6').removeClass('darkened');
                    $(this).parent().addClass('darkened');
                    $('.post-single-video .post-single-video-iframe').empty();
                    $('.post-single-video .post-single-video-iframe').append('<iframe title="' + $(this).find('.grid-item-title').text() + '" src="' + $(this).data('video-url') + '" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>');
                }
            })
        }
    });
}

module.exports = {
    init: init
};